import React from 'react'
import logo from '../../logo.svg'
import './Navbar.scss';


export default function Navbar() {
    return (
        <div className="">
            <nav className="navbar">
                <div className="container">
                <img src={logo} alt="city tour"/>
                <ul className="nav-links">
                    <li>
                        <a href="/"  className="nav-link">Home</a>
                    </li>
                    <li>
                        <a href="/"  className="nav-link">About</a>
                    </li>
                    <li>
                        <a href="/"  className="nav-link active">Tour</a>
                    </li>
                </ul>
                </div>
              
            </nav>
        </div>
    )
}
